export const authModule = {
  state: { 
    user: {
      user_id: '',
      first_name: '',
      last_name: '',
      email: '',
      is_user_signed_in: false
    }
  },
  mutations: {
    setUserId(state, user_id) {
      state.user.user_id = user_id;
    },
    setUserFirstName(state, first_name) {
      state.user.first_name = first_name;
    },
    setUserLastName(state, last_name) {
      state.user.last_name = last_name;
    },
    setUserEmail(state, email) {
      state.user.email = email;
    },
    setIsUserSignedIn(state, is_user_signed_in) {
      state.user.is_user_signed_in = is_user_signed_in
    },
  },
  getters: {
    getUserId: state => {
      return state.user.user_id
    },
    getIsUserSignedIn: state => {
      return state.user.is_user_signed_in
    },
    getUserFirstName: state => {
      return state.user.first_name
    },
    getUserLastName: state => {
      return state.user.last_name
    },  
  },
  actions: {
      
  }
}